export class CartView {
	constructor() {}

	removeSubEvent(subEventId) {
		return $(`.js-booking[data-sub-event-id=${subEventId}]`).remove();
	}

	updateSubscriptionCount(orderId) {
		let $count = this.getOrderById(orderId).find(".js-bookings-count");

		$count.text(parseInt($count.text()) - 1);

		return parseInt($count.text());
	}

	getOrderIdBySubEventId(subEventId) {
		return parseInt(
			$(`.js-booking[data-sub-event-id=${subEventId}]`).parents(".js-order").data("id")
		);
	}

	/**
	 * Удаляет и обновляет цены билетов
	 * @param order {object} - {
	 *   id {Number} - id заказа
	 *   amount, discount,
	 *   activeCarts {Object} - Ассоциативный массив получаем id мероприятия по названию
	 *   { 261: { summ, carts[{ id, price }, ... ], ... } }
	 *  }
	 */
	renderOrder(order) {
		const $order = $(`.js-order[data-id=${order.id}]`);
		let countTickets = 0;

		/* обновление суммы и скидки */
		$order.find(".js-sum").text(order.amount + (order.commission || 0));

		this.renderOrderDiscount(order.id, order.discount);

		$.each(this.getOrderEvents(order.id), (i, event) => {
			const eventId = $(event).data("event-id");

			/* Если в мероприятии нет билетов то удалем */
			if (!order.activeCarts[eventId]) return $(event).remove();

			/* Проходим по каждому билету */
			$.each(order.activeCarts[eventId].carts, (i, ticket) => {
				$(event)
					.find(`.tickets__item[data-id=${ticket.id}]`)
					.find(".js-ticket-price")
					.text(ticket.price);

				countTickets++;
			});

			$(event).find(".js-order-event-sum").text(order.activeCarts[eventId].summ);
		});

		if (!countTickets > 0) $order.remove();
		if (!$(".js-order").length > 0) return window.location.reload();
	}

	renderOrderDiscount(orderId, discount) {
		const $order = this.getOrderById(orderId);
		if (discount) {
			$order.find(".js-order-discount").show();
			return $order.find(".js-promo-discount").text(discount);
		}

		$order.find(".js-order-discount").hide();
		return $order.find(".js-promo-discount").text("0");
	}

	showSumLoader(orderId) {
		return this.getOrderById(orderId)
			.find(".js-sum")
			.html(
				`<span style="font-size: 9px;" class="spinner-circle spinner-circle_small spinner-circle_white"></span>`
			);
	}

	updateOrderSum(orderId, sum) {
		return this.getOrderById(orderId).find(".js-sum").text(sum);
	}

	removeOrderTickets(orderId, tickets) {
		$.each(tickets, (i, cart) =>
			this.getOrderById(orderId).find(`.tickets__item[data-id=${cart.id}]`).remove()
		);
	}

	getOrderById(orderId) {
		return $(`.js-order[data-id=${orderId}]`);
	}

	getOrderEvents(orderId) {
		return $(`.js-order[data-id=${orderId}]`).find(".js-order-event");
	}
}
